export const trainingCenterList = "TRAINING_CENTER_LIST";
export const states = "STATES";
export const cities = "CITIES";